import React from "react";
import Sample1 from "../components/Sample/Sample1";
import SEO from "../components/SEO";
const samplesSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Our Sample Works | Transforma Portfolio",
  "provider": {
    "@type": "Organization",
    "name": "Transforma Pvt Ltd",
    "url": "https://www.transforma.in/company/sample/Composition"
  },
  "description": "Explore Transforma's sample works and publishing portfolio. Preview high-quality examples of our composition services, artwork formatting, digital ePUB conversion, XML transformation, and Flash to HTML5 migration.",
  "keywords": "publishing sample works, transforma portfolio, typesetting composition samples, artwork design samples, digital conversion gallery, XML transformation examples, Flash to HTML5 migration, EditLaTeX interface"
};

const Sample = () => {
  return (
    <>
    <SEO 
        title="Our Sample Works & Portfolio | Digital Publishing Examples | Transforma"
        description="Browse Transforma's production portfolio. Check out our real-world samples for typesetting composition, custom artwork, digital conversion (ePUB/mobi), XML structural tagging, and Flash to HTML5 upgrades."
        keywords="publishing sample works, digital production portfolio, typesetting composition, artwork management, XML transformation samples, ePUB conversion examples, Flash to HTML5 conversion, EditLaTeX author solutions"
        canonical="https://www.transforma.in/company/sample/Composition"
        schema={samplesSchema}
      />
    <div className="w-full flex flex-col items-center ruler">
      <Sample1 />
    </div>
    </>
  );
};

export default Sample;
